<template>
  <v-tabs :scrollable="false">
    <v-tabs-bar dark class="green darken-1">
      <v-tabs-slider class="yellow"></v-tabs-slider>
      <v-tabs-item
        v-for="i in items"
        :key="i"
        :href="'#' + i"
      >
        {{ i }}
      </v-tabs-item>
    </v-tabs-bar>
    <v-tabs-items>
      <v-tabs-content id="Mission/Vision">
        <vision-mission></vision-mission>
      </v-tabs-content>
      <v-tabs-content id="Quality Policy">
        <quality-policy></quality-policy>
      </v-tabs-content>
      <v-tabs-content id="Organizational List">
        <org-list></org-list>
      </v-tabs-content>
      <v-tabs-content id="Academics">
        <academics></academics>
      </v-tabs-content>
      <v-tabs-content id="Goals">
        <goals></goals>
      </v-tabs-content>
      <v-tabs-content id="Core Values">
        <core-values></core-values>
      </v-tabs-content>
      <v-tabs-content id="History">
        <history></history>
      </v-tabs-content>
      <v-tabs-content id="ICS Seal">
        <seal></seal>
      </v-tabs-content>
    </v-tabs-items>
  </v-tabs>
  
</template>

<script>
import axios from 'axios'
import { VclCode } from 'vue-content-loading';
import VisionMission from './About/VisionMission.vue'
import QualityPolicy from './About/QualityPolicy.vue'
import OrgList from './About/OrgList.vue'
import Academics from './About/Academics.vue'
import Goals from './About/Goals.vue'
import CoreValues from './About/CoreValues.vue'
import History from './About/History.vue'
import Seal from './About/Seal.vue'
export default {
  components: {
    VclCode,
    VisionMission,
    QualityPolicy,
    OrgList,
    Academics,
    Goals,
    CoreValues,
    History,
    Seal
  },
  data(){
    return {
      mission: '',
      vision: '',
      orgCharts: [],
      loaded: false,
      items: ['Mission/Vision', 'Quality Policy', 'Organizational List', 'Academics', 'Goals', 'Core Values', 'History', 'ICS Seal']
    }
  },
  created(){
    axios.get('/api/about')
      .then(data => {
        // this.mission = data.data.mis_vis_go[0].config_value
        // this.vision = data.data.mis_vis_go[1].config_value
        // this.orgCharts = data.data.org_chart
        // this.loaded = true
      }).catch(e => {
        console.log(e)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/About.vue